import React, { useState } from "react";
import { Box, Button, IconButton } from "@mui/material";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  MoreHoriz,
} from "@mui/icons-material";
import AppMenuBar from "../AppMenuBar";

/**
 * @author Sarthak Sharma.
 * @since 27-12-2023.
 * @description Make Account Card component.
 */

const MakeAccountCard = (props) => {
  const { title, subTitle, onClickAdd, buttonText } = props;
  const [showModal, setShowModal] = useState(true); // Initially set to true

  return (
    <Box className="flex flex-col gap-1 p-5 w-full">
      <div className="flex items-start justify-between">
        <div className="text-neutral-800 text-base font-['Poppins-Medium'] leading-[30px]">
          {title}
        </div>
        <div>
          {/* <AppMenuBar>
                        <MoreHoriz />
                    </AppMenuBar> */}
          <IconButton
            size="small"
            onClick={() => setShowModal((prev) => !prev)} // Toggle visibility
          >
            {showModal ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </div>
      </div>
      <div className="text-neutral-800 text-sm font-['Poppins-Regular'] leading-[30px]">
        {subTitle}
      </div>

      <Box
        className="transition-[height] duration-200 flex items-center justify-center gap-10 mt-3"
        sx={{ height: showModal ? 120 : 0, width: "100%", overflowY: "hidden" }}
      >
        <Button
          onClick={onClickAdd}
          variant="contained"
          className="font-['Poppins-Medium'] normal-case text-[14px] text-white"
        >
          {buttonText}
        </Button>

      </Box>
    </Box>
  );
};

export default MakeAccountCard;
